<div class="connection-history" role="region" aria-label="Connection history">
  <!-- ITP-E-233-06: the ticket's sessions were asked from inside a demo. -->
  <div class="connection-history__demo" *ngIf="demoContext?.isDemo">
    <span class="connection-history__demo-chip" [attr.title]="demoTooltip" data-demo-chip>Raised from a demo</span>
    <span class="connection-history__demo-label">{{ demoContext.demoLabel }}</span>
  </div>
  <ol class="connection-history__rows">
    <li class="connection-history__row" *ngFor="let row of rows" [attr.data-kind]="row.kind">
      <span class="connection-history__what">{{ describe(row) }}</span>
      <span class="connection-history__when">{{ row.at | date:'d MMM y, HH:mm' }}</span>
    </li>
    <li class="connection-history__empty" *ngIf="!rows.length">No live support sessions yet.</li>
  </ol>

  <div class="connection-history__actions" *ngIf="disconnectableSessionId || canReconnect">
    <button type="button" class="connection-history__btn" *ngIf="disconnectableSessionId" [disabled]="!canDisconnect"
            (click)="disconnect()">Disconnect</button>
    <button type="button" class="connection-history__btn connection-history__btn--primary" *ngIf="canReconnect"
            [disabled]="busy" (click)="reconnect()">Reconnect</button>
  </div>
  <div class="connection-history__error" *ngIf="error">{{ error }}</div>

  <div class="connection-history__chat" *ngIf="latest">
    <app-xat-bot-live-support-chat [sessionId]="latest.sessionId" [myEmail]="myEmail"
                                   (sessionChange)="onSessionChange($event)"></app-xat-bot-live-support-chat>
  </div>
</div>
